import { Component, EventEmitter, Input, Output, ViewChild, Renderer2 } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RecaptchaComponent } from 'ng-recaptcha';
import { AuctionLotImageModel, PayInvoiceRequestModel } from 'src/app/models';
import { ScriptService, SquareService, InvoiceService } from 'src/app/services';
import { FormFunctions } from 'src/app/functions';

declare global {
    interface Window {
        Square: any;
        test: any;
    }
}

@Component({
    selector: 'modal-pay-invoice',
    styleUrls: ['./modal-pay-invoice.component.scss'],
    templateUrl: 'modal-pay-invoice.component.html'
})
export class ModalPayInvoiceComponent {
    @Input() InvoiceId: number;
    @Input() PayBalance: number;
    @Input() InvoiceNumber: string = "";

    processing: boolean = false;
    error: string = "";
    card = null;
    CaptchaToken: any;

    request: PayInvoiceRequestModel = new PayInvoiceRequestModel();

    @ViewChild("recaptcha") recaptcha: RecaptchaComponent;

    constructor(public activeModal: NgbActiveModal, public formFunctions: FormFunctions, public scriptService: ScriptService, public squareService: SquareService, private renderer: Renderer2, public invoiceService: InvoiceService) {
        let me = this;
    }

    ngOnInit() {
        let me = this;

        me.request.InvoiceId = me.InvoiceId;
        me.request.PaymentAmount = me.PayBalance;

        me.squareService.getSettings().subscribe(data => {
            // console.log('getSettings', data);
            me.loadSquareJs(data.ApplicationId, data.LocationId, data.Production ? 'https://web.squarecdn.com/v1/square.js' : 'https://sandbox.web.squarecdn.com/v1/square.js')
        });

    }

    loadSquareJs(appId, locationId, squareJsUrl) {
        let me = this;
        const scriptElement = this.scriptService.loadJsScript(this.renderer, squareJsUrl);
        scriptElement.onload = async () => {
            if (!window.Square) {
                throw new Error('Square.js failed to load properly');
            }
            const payments = window.Square.payments(appId, locationId);
            try {
                this.card = await me.initializeCard(payments);
                this.processing = false;
            } catch (e) {
                console.error('Initializing Card failed', e);
                return;
            }
        };
        scriptElement.onerror = () => {
            //   console.log('Could not load the Square API Script!');
        };
    }

    async initializeCard(payments) {
        const card = await payments.card();
        await card.attach('#card-container');
        return card;
    }

    // This function tokenizes a payment method. 
    // The ‘error’ thrown from this async function denotes a failed tokenization,
    // which is due to buyer error (such as an expired card). It is up to the
    // developer to handle the error and provide the buyer the chance to fix
    // their mistakes.
    async tokenize(paymentMethod) {
        const tokenResult = await paymentMethod.tokenize();
        if (tokenResult.status === 'OK') {
            debugger;
            return tokenResult.token;
        } else {
            let errorMessage = `Tokenization failed-status: ${tokenResult.status}`;
            if (tokenResult.errors) {
                errorMessage += ` and errors: ${JSON.stringify(
                    tokenResult.errors
                )}`;
            }
            throw new Error(errorMessage);
        }
    }

    async handlePaymentMethodSubmission(paymentMethod) {
        // event.preventDefault();
        let me = this;

        try {
            // disable the submit button as we await tokenization and make a
            // payment request.
            me.processing = true;
            const token = await me.tokenize(paymentMethod);

            me.request.PaymentToken = token;

            if (me.error) me.error = '';
            me.processing = false;

        } catch (e) {
            me.error = 'Tokenization failed';
            console.error(e.message);
        }
        me.processing = false;
    }

    async Save(form, e) {
        let me = this;
        me.error = "";

        if (me.formFunctions.isFormValid(form, e)) {
            me.processing = true;

            await this.handlePaymentMethodSubmission(this.card);
            debugger;
            me.invoiceService.PayInvoice(me.request).subscribe(data => {
                if (data.Success) {
                    alert('Invoice paid successfully');
                    me.activeModal.close(data);
                } else {
                    alert(data.Message);
                }
            });
            // me.customerService.register(me.request).subscribe(data => {
            //     if (data && data.Success) {
            //         me.stateService.changeUserModel(data.User);
            //         if (me.successRedirect != '') {
            //             me.router.navigate([me.successRedirect]);
            //         } else {
            //             me.onSuccess.emit(data.User.Id);
            //         }
            //     } else {
            //         this.recaptcha.reset();
            //         if (data?.Message) me.error = data?.Message;
            //     }
            //     me.processing = false;

            // }, err => {
            //     me.processing = false;
            //     me.error = "Something went wrong. Please try again"

            //     if (err.status != 401) {
            //         this.recaptcha.reset();
            //         if (err?.error?.Message) me.error = err?.error?.Message;
            //     }
            // });
        } else {
            me.error = "Please complete all fields.";
        }
    }
}